module.exports = __webpack_public_path__ + "img/stickers_0001_bucket.0be9ade0.png";